export default "__VITE_ASSET__DeNaa_Gu__"